import { render, staticRenderFns } from "./BtnTop.vue?vue&type=template&id=3b647c15&scoped=true"
import script from "./BtnTop.vue?vue&type=script&lang=js"
export * from "./BtnTop.vue?vue&type=script&lang=js"
import style0 from "./BtnTop.vue?vue&type=style&index=0&id=3b647c15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b647c15",
  null
  
)

export default component.exports